/**
 * Display configuration for credit card brands
 */
export const CARD_BRAND_DISPLAY: Record<string, { name: string; color: string }> = {
  visa: { name: 'Visa', color: 'text-blue-600' },
  mastercard: { name: 'Mastercard', color: 'text-orange-600' },
  amex: { name: 'Amex', color: 'text-blue-800' },
  discover: { name: 'Discover', color: 'text-orange-500' },
  diners: { name: 'Diners', color: 'text-gray-700' },
  jcb: { name: 'JCB', color: 'text-green-600' },
  unionpay: { name: 'UnionPay', color: 'text-red-600' },
};

/**
 * Get brand display info with fallback
 */
export function getBrandDisplay(brand: string): { name: string; color: string } {
  return CARD_BRAND_DISPLAY[brand.toLowerCase()] || { name: brand, color: 'text-gray-700' };
}
